import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Select from "../../../../../parts/inputs/select";
import SvgIcon from "../../../../../parts/SvgIcon";
import { getInsightsLensOptions } from "../../../../../utils/insights-lens";

export const NOT_DEFINED_LENS = "";

export const TemplateInsightsLensSelect = ({
  value,
  onChange,
  allowNotDefined = false,
}: {
  value: string;
  onChange: (value: string) => void;
  /** Only for templates saved without a lens before the feature existed. */
  allowNotDefined?: boolean;
}) => {
  const { t } = useTranslation(["athlete-portal", "dashboard"]);

  const options = useMemo(
    () => [
      ...(allowNotDefined
        ? [
            {
              value: NOT_DEFINED_LENS,
              label: t("clientConfiguration.templateLens.notDefined"),
            },
          ]
        : []),
      ...getInsightsLensOptions(t),
    ],
    [t, allowNotDefined]
  );

  return (
    <div className="client-config-card template">
      <div className="client-config-card__left">
        <legend className="client-config-template-bar__label">
          <SvgIcon classNames="shrink-0" src="/img/new-icons/stats-chart.svg" />
          <span className="p4 font-semibold">
            {t("clientConfiguration.templateLens.label")}
          </span>
        </legend>
        <div className="client-config-template-bar__field">
          <label
            className="sr-only"
            htmlFor="client-config-template-insights-lens-select"
          >
            {t("clientConfiguration.templateLens.selectLabel")}
          </label>
          <div className="select client-config-template__select">
            <Select
              name="client-config-template-insights-lens-select"
              disabled={false}
              options={options}
              value={value}
              onChange={onChange}
              overlay
            />
          </div>
        </div>
      </div>
    </div>
  );
};
